import React, {useState,useEffect} from 'react'
import {FormValidator,useFormValidator,Inputs} from 'coaz-ui';
import client from '../client';

const SetPassword = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [currentPassword,setCurrentPassword] = useState("");
    const [newPassword,setNewPassword] = useState("");
    const [confirmPassword,setConfirmPassword] = useState("");
    const minWidth = 240;
    const {request,errorMessage} = client;

    const submit = async () => {
        if(!params || !params.username) {
            return {
                message:"No username"
            }
        }
        if(newPassword !== confirmPassword) {
            return {
                message:"New password and confirm password didn't match, try again!"
            }
        }
        try {
            const response = await request('PUT','users/set-password',null,
            {
                username:params.username,
                currentPassword:currentPassword,
                newPassword:newPassword
            });

            if (response) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'Current Password',
            type:'password',
            name:'currentPassword', 
            value:currentPassword?currentPassword:'',
            placeholder:'Enter current password...',
            onChange:(e) => handleChange(e,(e) => {
                setCurrentPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'New Password',
            type:'password',
            name:'newPassword', 
            value:newPassword?newPassword:'',
            placeholder:'Enter new password...',
            onChange:(e) => handleChange(e,(e) => {
                setNewPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Confirm Password',
            type:'password',
            name:'confirmPassword', 
            value:confirmPassword?confirmPassword:'',
            placeholder:'Enter current password...',
            onChange:(e) => handleChange(e,(e) => {
                setConfirmPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        setLoading && setLoading(false);
    },[])
 
    return (
        <FormValidator>
            <div className='flex flex-col w-full h-auto'>
                <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
            </div>
        </FormValidator>
    )
}

export default SetPassword
